<template>
  <div class="bg-white rounded box-shadow p-3">
    <b-modal hide-footer id="trainee-exam-grade-view" size="lg" title="Grade">
      <div class="modal-content bg-white rounded box-shadow">
        <div class="row">
          <div class="col-md-12">
            <b-card>
              <div class="row mb-2">
                <div class="col-md-6">
                  <span v-if="trainee_grades.length > 0" class="badge badge-success mr-2">Total Search Data Found: {{ trainee_grades.length }}</span>
                </div>
                <div class="col-md-6">
                  <download-excel
                      class = "btn btn-light btn-sm float-right"
                      :data = "trainee_grades"
                      :fields = "trainee_grade_fields"
                      :meta="json_meta"
                      worksheet = "Trainee grade"
                      name = "trainee-grade.xls">
                    Download Excel
                  </download-excel>
                </div>
              </div>
              <div class="table-responsive" style="overflow-x: auto">
                <table class="table table-centered table-striped">
                  <thead>
                  <tr>
                    <th>Sl</th>
                    <th>Exam</th>
                    <th>Exam Date</th>
                    <th>Mark</th>
                    <th>Grade</th>
                    <th>Remark</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(trainee_grade, index) in trainee_grades" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ trainee_grade.trainee_exam.title }}</td>
                    <td>{{ trainee_grade.trainee_exam.date }}</td>
                    <td>{{ trainee_grade.marks }}</td>
                    <td>{{ trainee_grade.grade }}</td>
                    <td>{{ trainee_grade.remarks }}</td>
                  </tr>
                  </tbody>
                </table>
                <h5 v-if="trainee_grades.length === 0"
                    class="text-center text-secondary">
                  No Data Found
                </h5>
              </div>
            </b-card>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  name: "Update",
  props: ["trainee_grades", "trainee_name"],
  components: { },
  data() {
    return {
      title: "Trainee Grade List",
      items: [
        {
          text: "Grade",
          href: "/"
        },
        {
          text: "Dashboard",
          active: true
        }
      ],
      trainee_grade: {},
      btn_edit: false,
      trainee_grade_fields: {
        'Exam': 'trainee_exam.title',
        'Exam Date': 'trainee_exam.date',
        'Grade' : {
          callback: (value) => {
            return `${value.grade ? value.grade : "N/A"}`;
          }
        },
        'Marks' : {
          callback: (value) => {
            return `${value.marks ? value.marks : "N/A"}`;
          }
        },
        'Remarks' : {
          callback: (value) => {
            return `${value.remarks ? value.remarks : "N/A"}`;
          }
        },
      },
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
    };
  },
  mounted() {

  },
  methods: {

  },
};
</script>


